module.exports = __webpack_public_path__ + "static/media/onhold.9d14e388.svg";